/* ==========================================================================
   cdc-article.js — Prix dynamiques des product cards d'article de blog
   --------------------------------------------------------------------------
   ROLE
   Rafraichit le prix affiche dans les product cards des articles de blog a
   partir de /products/{handle}.js. Le HTML de l'article contient un prix de
   secours ecrit en dur : si ce script ne s'execute pas, la card reste correcte.

   Remplace le <script> qui etait duplique dans le corps de CHAQUE article.

   CHARGEMENT
   layout/theme.liquid, dans la meme condition que cdc-article.css :
       {% if request.page_type == 'article' %}
         {{ 'cdc-article.css' | asset_url | stylesheet_tag }}
         <script src="{{ 'cdc-article.js' | asset_url }}" defer></script>
       {% endif %}

   MARKUP ATTENDU (cf. _audits/2026-07-16-articles-enjolives/prompt-v3.md)
       <span class="cdc-shop-card__price" data-product-price data-handle="HANDLE">
         <span class="cdc-shop-card__current">40,90 €</span>
         <span class="cdc-shop-card__old-price is-empty">&nbsp;</span>
       </span>

   ⚠ La balise du prix barre doit TOUJOURS etre presente, meme sans promo
   (masquee par `.is-empty`). Si elle est inseree a l'arrivee de la reponse,
   elle decale le contenu : +0,007 de CLS par card (mesure).

   CHOIX D'IMPLEMENTATION
   - dedoublonnage par handle : deux cards du meme produit = une seule requete
   - requestIdleCallback : n'entre pas en concurrence avec le rendu initial
   - ecriture uniquement si la valeur differe du prix de secours : evite un
     repaint inutile quand le prix en dur est deja a jour
   ========================================================================== */
(function () {
  var nodes = document.querySelectorAll('[data-product-price][data-handle]');
  if (!nodes.length) return;

  var byHandle = {};
  Array.prototype.forEach.call(nodes, function (el) {
    var handle = el.getAttribute('data-handle');
    if (!handle) return;
    (byHandle[handle] = byHandle[handle] || []).push(el);
  });

  function format(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function apply(el, product) {
    var current = el.querySelector('.cdc-shop-card__current');
    var old = el.querySelector('.cdc-shop-card__old-price');

    if (current) {
      var price = format(product.price);
      if (current.textContent.trim() !== price) current.textContent = price;
    }

    if (!old) return;

    if (product.compare_at_price && product.compare_at_price > product.price) {
      var compare = format(product.compare_at_price);
      if (old.textContent.trim() !== compare) old.textContent = compare;
      old.classList.remove('is-empty');
    } else {
      old.innerHTML = '&nbsp;';
      old.classList.add('is-empty');
    }
  }

  function run() {
    Object.keys(byHandle).forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .then(function (product) {
          if (!product || !product.price) return;
          byHandle[handle].forEach(function (el) {
            apply(el, product);
          });
        })
        .catch(function () {
          /* le prix de secours reste affiche */
        });
    });
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(run, { timeout: 3000 });
  } else {
    setTimeout(run, 1500);
  }
})();
